import { HttpClient } from '@angular/common/http';
import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

const IMAGE_MIME_TYPE_PREFIX = 'image/';
const EMPTY_IMAGE_URL: SafeUrl = '';

@Pipe({
    name: 'image',
    standalone: false
})
export class ImagePipe implements PipeTransform {
  constructor(private http: HttpClient, private sanitizer: DomSanitizer) {}

  public transform(url: string): Observable<SafeUrl> {
    return this.http
      .get(url, {
        headers: { Accept: 'image/jpeg', 'Content-Type': 'image/*', omitLoader: 'true' },
        responseType: 'blob'
      })
      .pipe(
        map(blob => this.toSafeImageUrl(blob)),
        catchError(() => of(EMPTY_IMAGE_URL))
      );
  }

  private toSafeImageUrl(blob: Blob): SafeUrl {
    return blob.type.startsWith(IMAGE_MIME_TYPE_PREFIX)
      ? this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob))
      : EMPTY_IMAGE_URL;
  }
}
